.root {
  display: inline-flex;
  height: 1.5rem;
  min-width: max-content;
  max-height: 1.5rem;
  min-height: 1.5rem;
  padding: 0 0.375rem;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
  border-radius: 0.375rem;
  text-transform: capitalize;
}

.root[data-status="info"] {
  background-color: var(--sentiment-background-info);
  color: var(--sentiment-text-info);
}

.root[data-status="neutral"] {
  background-color: var(--sentiment-background-neutral);
  color: var(--static-text-strong);
}

.root[data-status="success"] {
  background-color: var(--sentiment-background-positive);
  color: var(--sentiment-text-positive);
}

.root[data-status="warning"] {
  background-color: var(--sentiment-background-notice);
  color: var(--sentiment-text-notice);
}

.root[data-status="danger"] {
  background-color: var(--sentiment-background-negative);
  color: var(--sentiment-text-negative);
}